import { render } from "./AbsenceObject.vue?vue&type=template&id=ced3fd74"
import script from "./AbsenceObject.vue?vue&type=script&lang=js"
export * from "./AbsenceObject.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jellevanoosterbosch/PhpstormProjects/haaer/haaer-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__